import { humanizeEnum } from '../../common/utils';
import { SORT } from '../../common/constants';

export const INVENTORY_UNIT_STATUS = {
  PENDING_INDUCTION: { label: 'Pending Induction', color: 'default' },
  AVAILABLE: { label: 'Available', color: 'success' },
  PICKED: { label: 'Picked', color: 'processing' },
  PACKED: { label: 'Packed', color: 'processing' },
  READY_TO_SHIP: { label: 'Ready To Ship', color: 'cyan' },
  DELIVERED: { label: 'Delivered', color: 'blue' },
  RETURN_PICKED_UP: { label: 'Return Picked Up', color: 'purple' },
  INWARD_PENDING_VERIFICATION: {
    label: 'Inward Pending Verification',
    color: 'gold',
  },
  INCOMPLETE: { label: 'Incomplete', color: 'warning' },
  DAMAGED_UNDER_REVIEW: { label: 'Damaged Under Review', color: 'error' },
  WRITTEN_OFF: { label: 'Written Off', color: 'magenta' },
};

export const INVENTORY_UNIT_QR_IMAGE_STATUS = {
  PENDING: { label: 'Pending', color: 'warning' },
  PROCESSING: { label: 'Processing', color: 'processing' },
  GENERATED: { label: 'Generated', color: 'success' },
  FAILED: { label: 'Failed', color: 'error' },
};

export const INVENTORY_UNIT_QR_ACTIVE_OPTIONS = [
  { label: 'Active', value: true },
  { label: 'Inactive', value: false },
];

export const INVENTORY_UNIT_SORT_FIELDS = {
  UNIT_NUMBER: 'unitNumber',
  UNIT_CODE: 'unitCode',
  CREATED_AT: 'createdAt',
};

export const INVENTORY_UNITS_DEFAULT_SORT = {
  field: INVENTORY_UNIT_SORT_FIELDS?.UNIT_NUMBER,
  order: SORT?.ASC,
};

export const INVENTORY_UNITS_DEFAULT_PAGINATION = {
  current: 1,
  pageSize: 10,
};

export const INVENTORY_UNITS_DEFAULT_FILTERS = {
  search: '',
  status: undefined,
  isQrActive: undefined,
  qrImageStatus: undefined,
};

export const INVENTORY_UNIT_LOG_RESULT = {
  SUCCESS: { label: 'Success', color: 'success' },
  PARTIAL: { label: 'Partial', color: 'warning' },
  FAILED: { label: 'Failed', color: 'error' },
  OVERRIDDEN: { label: 'Overridden', color: 'purple' },
};

export const INVENTORY_UNIT_LOG_SORT_FIELDS = {
  CREATED_AT: 'createdAt',
  SEQUENCE_NO: 'sequenceNo',
};

export const INVENTORY_UNIT_LOGS_DEFAULT_SORT = {
  field: INVENTORY_UNIT_LOG_SORT_FIELDS?.CREATED_AT,
  order: SORT?.DESC,
};

export const INVENTORY_UNIT_LOGS_DEFAULT_PAGINATION = {
  current: 1,
  pageSize: 5,
};

export const INVENTORY_UNIT_LOGS_PAGE_SIZE_OPTIONS = [5, 10, 20, 50];

export const TOOLTIP_Z_INDEX = 1070;

export { humanizeEnum };

export const getEnumConfig = (configMap, value) =>
  configMap?.[value] || { label: humanizeEnum(value), color: 'default' };

export const toSelectOptions = (configMap) =>
  Object.entries(configMap || {})?.map(([value, config]) => ({
    value,
    label: config?.label,
  }));

export const TRANSFER_UNIT_RESULT = {
  MOVED: { label: 'Moved', color: 'success' },
  ALREADY_IN_LIBRARY: { label: 'Already in this library', color: 'default' },
  UNIT_NOT_FOUND: { label: 'Unit not found', color: 'error' },
  UNIT_IN_ACTIVE_ORDER: {
    label: 'In an active order',
    color: 'warning',
    hint: 'Complete the order before moving this unit.',
  },
  TARGET_INVENTORY_NOT_FOUND: {
    label: 'Toy not in target library',
    color: 'error',
    hint: 'Add this toy to the target library first.',
  },
};

export const TRANSFER_UNIT_MOVED_RESULT = 'MOVED';

export const UNIT_RETURN_ORDER_STATUS = {
  RETURN_REQUESTED: { text: 'Return requested', color: '#FFA500' },
  READY_TO_PICKUP: { text: 'Ready to pickup', color: '#FF8C00' },
  PICKED_UP: { text: 'Picked-up', color: '#800080' },
  RETURNED: { text: 'Returned', color: '#20B2AA' },
  RETURN_CONFIRMED: { text: 'Return confirmed', color: '#006400' },
  NOT_PICKED_UP: { text: 'Not picked up', color: '#ff0000' },
};
